<template>
  <v-container class="mt-8">
    <v-card class="rounded-lg">

      <v-tabs class="text-h4 tab-no-arrow rounded-t-lg overflow-hidden" v-model="tab">
        <v-tab to="/admin">Home</v-tab>
        <v-tab to="/admin/approval">Approval List</v-tab>
        <v-tab to="/admin/usermanager">User Management</v-tab>
        <v-tab to="/admin/websetting">Setting</v-tab>
        <v-tab to="/admin/logs">Logs</v-tab>
      </v-tabs>

      <router-view class="px-4"></router-view>

    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      tab: null,
    };
  },
  metaInfo() {
    return {
      title: "Admin Panel",
      titleTemplate: "%s · Marketpett",
      // meta: [{ name: "robots", content: "noindex" }],
    };
  },
};
</script>

<style>
</style>